import axiosInstance from 'api/axiosInstance';
import { TicketFilter } from 'containers/pages/CANpark/components/ticketsTable/TicketsTableFilterBar';
import { Ticket } from 'containers/pages/CANpark/types/ticket';

export const getTicketsByParkingLocation = async (
	parkingLocationId: string,
	filter: TicketFilter,
): Promise<Ticket[]> => {
	try {
		// ✅ Construct query parameters from filter object
		const params = new URLSearchParams({
			parkingLocationId: parkingLocationId,
			ticketNumber: filter.ticketNumber || '',
			licensePlate: filter.licensePlate || '',
			showLog: String(filter.showLog),
			showLogAndWarn: String(filter.showLogAndWarn),
			showTow: String(filter.showTow),
			items_per_page: String(filter.items_per_page),
			page: String(filter.page),
		});

		if (filter.startDate) params.append('startDate', filter.startDate);
		if (filter.endDate) params.append('endDate', filter.endDate);

		const API_URL = `/api2.0/tickets/getTicketsByParkingLocation?${params.toString()}`;
		const response = await axiosInstance.get(API_URL);

		// ✅ Convert response data to proper format
		const formattedTickets: Ticket[] = response.data.map(
			(ticket: any) =>
				({
					ticketNumber: ticket.ticketNumber,
					ticketType: ticket.ticketType,
					parkingLocationId: ticket.parkingLocationId,
					parkingZone: ticket.parkingZone,
					licenseNumber: ticket.licenseNumber,
					licenseState: ticket.licenseState,
					date: new Date(ticket.date), // Convert from ISO string to Date object
					vehicleInfo: ticket.vehicleInfo,
					issuedBy: ticket.issuedBy,
					comments: ticket.comments || '',
					isVoid: ticket.isVoid === 'True',
					attachments:
						ticket.attachments?.map((att: any) => ({
							AttachmentID: att.AttachmentID,
							Name: att.Name,
							Size: att.Size,
							ContentType: att.ContentType,
						})) || [],
				} as Ticket),
		);

		return formattedTickets;
	} catch (error) {
		console.error('❌ Error fetching tickets:', error);
		throw error;
	}
};
